<app-page-content>
<app-doenkids-menu-bar menuBar></app-doenkids-menu-bar>
<div content class="main-content">
  @if (showThemeSwitcher$ | async) {
    <div class="theme-switcher">
      <mat-form-field appearance="outline">
        <mat-label>Debug: Theme Switcher</mat-label>
        <mat-select [value]="(currentTheme$ | async)?.id" (selectionChange)="onThemeChange($event.value)">
          @for (theme of availableThemes; track theme.id) {
            <mat-option [value]="theme">{{ theme.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
    @if ((isCustomer$ | async) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) {
      <mat-tab [label]="'settings_overview.tab.tags' | translate">
        <app-tags></app-tags>
      </mat-tab>
    }
    @if ((isCustomer$ | async) && (hasWritePermissionOnAtLeastOneCustomerOUInCurrentNodeTree$ | async)) {
      <mat-tab [label]="'settings_overview.tab.program_category' | translate">
        <app-program-category-list></app-program-category-list>
      </mat-tab>
    }
    <mat-tab [label]="'settings_overview.tab.preferences' | translate">
      <app-user-preferences></app-user-preferences>
    </mat-tab>
  </mat-tab-group>
</div>
</app-page-content>
